(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ProcedureDeleteController',ProcedureDeleteController);

    ProcedureDeleteController.$inject = ['$uibModalInstance', 'entity', 'Procedure'];

    function ProcedureDeleteController($uibModalInstance, entity, Procedure) {
        var vm = this;

        vm.procedure = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Procedure.deleteProcedure({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
